import { useEffect, useState } from 'react';

/**
 * Abaixo desta largura as barras laterais viram gavetas sobrepostas. Acima
 * delas cabem as tres colunas (guildas + canais + membros) sem espremer o chat.
 *
 * O mesmo numero esta no styles.css; se mudar aqui, mude la — o CSS decide o
 * desenho e o JS decide o comportamento (fechar a gaveta ao escolher um canal),
 * e os dois precisam concordar sobre o que e "celular".
 */
export const LARGURA_CELULAR = 820;

/** Verdadeiro quando a janela esta em largura de celular, acompanhando o resize. */
export function useCelular(): boolean {
  const [celular, setCelular] = useState(
    () => typeof window !== 'undefined' && window.innerWidth <= LARGURA_CELULAR,
  );

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${LARGURA_CELULAR}px)`);
    const aplicar = () => setCelular(media.matches);
    aplicar();
    media.addEventListener('change', aplicar);
    return () => media.removeEventListener('change', aplicar);
  }, []);

  return celular;
}
